var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _emit, _internals, _handleClick, handleClick_fn;
import "element-internals-polyfill";
import { eventEmitter } from "@horizon/common/events";
import { HasSlotController } from "@horizon/common/controllers";
import { html } from "@horizon/base/static-html.js";
import { ifDefined, live } from "@horizon/base/directives.js";
import { LitElement, nothing } from "@horizon/base";
import { property, query } from "@horizon/base/decorators.js";
import { submit } from "@open-wc/form-helpers";
import IconButtonStyles from "./icon-button.css.js";
class HznIconButton extends LitElement {
  constructor() {
    super(...arguments);
    /**
     * @private
     */
    __privateAdd(this, _handleClick);
    /**
     * @private
     */
    __privateAdd(this, _emit, eventEmitter(this));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    __privateAdd(this, _internals, void 0);
    this.hasSlotController = new HasSlotController(this, "[default]");
    this.compact = false;
    this.filled = false;
    this.outlined = false;
    this.tone = "neutral";
    this.disabled = false;
    this.label = "icon button";
  }
  /**
   * Focus the innerButton
   */
  focus(options) {
    this.innerButton.focus(options);
  }
  /**
   * Remove focus from the innerButton
   */
  blur() {
    this.innerButton.blur();
  }
  connectedCallback() {
    super.connectedCallback();
    if (!__privateGet(this, _internals)) {
      __privateSet(this, _internals, this.attachInternals());
    }
  }
  /**
   * Simulates a click on the button
   */
  click() {
    if (this.innerButton) {
      this.innerButton.click();
    }
  }
  // NOTE: if download, generate an anchor tag (CSS hidden) with the download and href attributes
  render() {
    return html`<button
      ?disabled=${live(this.disabled)}
      @click=${__privateMethod(this, _handleClick, handleClick_fn)}
      aria-label=${ifDefined(this.label)}
      class="hzn-icon-button"
      name=${ifDefined(this.name)}
      role="button"
      type=${ifDefined(this.type)}
    >
      <slot></slot>
    </button>
    ${this.download ? html`<a download href=${this.download} hidden></a>` : nothing}
  `;
  }
}
_emit = new WeakMap();
_internals = new WeakMap();
_handleClick = new WeakSet();
handleClick_fn = function($event) {
  $event.preventDefault();
  $event.stopImmediatePropagation();
  const emitClick = () => __privateGet(this, _emit).call(this, {
    type: "click",
    eventOptions: {
      detail: {
        name: this.name || void 0
      }
    }
  });
  if (!this.disabled) {
    if (this.download) {
      this.shadowRoot.querySelector("a[download]").click();
      return;
    }
    if (!__privateGet(this, _internals).form) {
      emitClick();
      return;
    }
    if (this.type === "submit" || !this.type) {
      emitClick();
      submit(__privateGet(this, _internals).form);
    } else if (this.type === "reset") {
      emitClick();
      __privateGet(this, _internals).form.reset();
    } else if (this.type === "button") {
      emitClick();
    }
  }
};
HznIconButton.formAssociated = true;
HznIconButton.styles = [IconButtonStyles];
HznIconButton.shadowRootOptions = { ...LitElement.shadowRootOptions, mode: "open", delegatesFocus: true };
__decorateClass([
  query(".hzn-icon-button")
], HznIconButton.prototype, "innerButton", 2);
__decorateClass([
  property({ type: Boolean })
], HznIconButton.prototype, "compact", 2);
__decorateClass([
  property({ type: Boolean })
], HznIconButton.prototype, "filled", 2);
__decorateClass([
  property({ type: Boolean })
], HznIconButton.prototype, "outlined", 2);
__decorateClass([
  property({ type: String, reflect: true })
], HznIconButton.prototype, "tone", 2);
__decorateClass([
  property({ type: Boolean })
], HznIconButton.prototype, "disabled", 2);
__decorateClass([
  property({ type: String })
], HznIconButton.prototype, "download", 2);
__decorateClass([
  property({ type: String })
], HznIconButton.prototype, "name", 2);
__decorateClass([
  property({ type: Boolean })
], HznIconButton.prototype, "square", 2);
__decorateClass([
  property({ type: String, reflect: true })
], HznIconButton.prototype, "type", 2);
__decorateClass([
  property({ type: String })
], HznIconButton.prototype, "label", 2);
export {
  HznIconButton
};
//# sourceMappingURL=icon-button.js.map
